import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register the service worker for PWA capabilities (offline shell + install
// prompt + Web Push). The SW is intentionally light: it never caches /api/*
// and only precaches static assets. Bump CACHE_VERSION in sw.js to force
// clients to re-fetch after a breaking UI change.
//
// Registered in BOTH dev and prod so push notifications can be tested locally.
// (CRA hot-reload still works because the SW only caches static GET assets.)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("[SW] registration failed:", err));
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
